<template>
  <div
    v-if="imagedata.imagetype=='default' || imagedata.imagetype=='screen'"
    class="col-xs-12 col-sm-12 p-0"
    :class="[(imagedata.align =='right' && !paddingImage)?'col-md-push-6':'',
    (imagedata.bg_color!== undefined && imagedata.bg_color=='default')?'bg-color-blue':'',
     paddingImage ? 'col-md-4 col-lg-4' : 'col-md-6']"
  >
  <img class="img-style"
    :class="{'p-50': paddingImage, 'default-style': imagedata.imagetype=='default', 'img-style': imagedata.imagetype=='screen', 'gg-style': imagedata.gg_img}"
    :src="`${getImageUrl(imagedata.image)}`" alt="img">
  </div>
  <div
    v-else
    class="col-xs-12 col-sm-12 col-md-6 p-0"
    :class="{'laptop-wrapper': imagedata.imagetype=='laptop'}"
    :style="[imagedata.imagetype=='laptop'?{'height':laptopBlockHeight+'px'}:'']"
  >
    <div v-if="imagedata.imagetype=='desktop'" class="img-center desktop-wrapper">
      <div class="col-xs-12 mt-10 col-sm-12">
        <div class="col-xs-12 col-sm-11 desktop-border">
          <div class="col-xs-12 plr-5 mtb-2">
            <div class="col-xs-offset-7 col-xs-5 desktop-top-gradient"></div>
          </div>
          <div class="col-xs-12 p-0 rs-image">
            <img :src="getImageUrl(imagedata.image)" class="desktop-image" width="100%" alt="rs-img"/>
          </div>
        </div>
        <div class="col-xs-12 col-sm-11 desktop-bottom"></div>

        <div class="col-xs-12 col-sm-11 text-align-center">
          <img src="/static/images/marketplace/computer_stand.png" alt="computer-img"/>
        </div>
      </div>
    </div>
    <div v-if="imagedata.imagetype=='laptop'" class="img-center laptop-block">
      <div class="row mt-10">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1">
          <div class="row">
            <div class="col-xs-10 col-xs-offset-1 laptop-box">
              <div class="col-xs-12 p-0 rs-image">
                <img :src="getImageUrl(imagedata.image)" class="laptop-image" width="100%" alt="rs-img"/>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div data-v-7abf919a class="col-xs-12 col-sm-12 laptop-bottom">
              <div data-v-7abf919a class="col-xs-6 p-0 laptop-bottom-gradient"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['imagedata', 'sasToken', 'laptopBlockHeight', 'serviceId', 'paddingImage'],
  data() {
    return {};
  },
  methods: {
    getImageUrl(filePath) {
      return `${process.env.VUE_APP_AZURE_BLOB_URL}/${filePath}?${this.sasToken}`;
    },
  },
  watch: {
    laptopBlockHeight() {},
  },
};
</script>
<style scoped>
.p-50 {
  padding: 50px 0px;
}
.img-style {
  width: 100%;
  height: auto;
}
.default-style {
  width: 100%;
  height: 100%;
  flex: 0 0 40%;
}
.gg-style {
  width: 85%;
  height: 85%;
  padding-left: 20px;
}
.bg-color-blue {
  background: #00518a;
}
.plr-5 {
  padding: 0 5px;
}
.mtb-2 {
  margin: 2px 0 3px;
}
.laptop-wrapper {
  display: table;
  height: 100%;
}
.laptop-block {
  display: table-cell;
  vertical-align: middle;
}
.text-align-center {
  text-align: center;
}
.img-height {
  height: 425px;
  width: 100%;
}
.p-0 {
  padding: 0px;
}
.img-center {
  text-align: center;
}
.text-align-left {
  text-align: left;
}
.desktop-border {
  background: #ffffff;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 7px 7px 0 0;
}
.desktop-bottom {
  height: 47.02px;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
    #c4c4c4;
  border: 1px solid #0b3c61;
  border-top: 0;
  box-sizing: border-box;
  border-radius: 0px 0px 7px 7px;
}
.desktop-top-gradient {
  height: 9px;
  background-image: linear-gradient(
    to bottom right,
    transparent,
    transparent 50%,
    #d3d6d9 53%,
    #d3d6d9
  );
  border-radius: 0 7px 7px 0;
}
.desktop-bottom-gradient {
  height: 38px;
  background-image: linear-gradient(
    to top left,
    transparent,
    transparent 50%,
    #d3d6d9 50%,
    #d3d6d9
  );
}
.desktop-handler-top {
  border: 1px solid #0b3c61;
  border-bottom: 0;
  border-top: 0;
  padding: 5px;
}
.desktop-handler-bottom-right {
  height: 35px;
  border-right: 1px solid #0b3c61;
  border-bottom: 1px solid #0b3c61;
  border-radius: 39px 0px 26px 0px;
  transform: skewX(40deg);
  display: inline-block;
  width: 100px;
  position: relative;
  top: 0px;
  left: 37px;
}
.desktop-handler-bottom-left {
  height: 35px;
  border-left: 1px solid #0b3c61;
  border-bottom: 1px solid #0b3c61;
  border-radius: 0 44px 0 26px;
  transform: skewX(-37deg);
  display: inline-block;
  width: 100px;
  position: absolute;
  left: 15px;
}
.rs-image {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px;
  margin-bottom: 2px;
}
.laptop-box {
  padding: 15px;
  background: #f2f2f2;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 7px 7px 0 0;
  border-bottom: 0;
}
.laptop-bottom {
  background: #f2f2f2;
  border: 1px solid #0b3c61;
  box-sizing: border-box;
  border-radius: 0px 0px 7px 7px;
  padding: 2px 0px 0;
}
.laptop-bottom-gradient {
  height: 13px;
  background-image: linear-gradient(
    to bottom left,
    transparent,
    transparent 50%,
    #d3d6d9 52%,
    #d3d6d9
  );
  border-radius: 7px 0px 0px 7px;
}
.laptop-bottom-gradient .rs-image {
  box-shadow: none;
}
.desktop-image {
  height: 230px;
}
.laptop-image {
  height: 200px;
}
@media screen and (max-width: 767px) {
  .desktop-image {
    height: 200px;
  }
  .desktop-wrapper {
    margin-bottom: 20px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .desktop-image {
    height: 200px;
  }
  .laptop-image {
    height: 180px;
  }
}
</style>
